import React from 'react'
import { SVGIcon } from '../wrappers/SVGIcon';
import { Icons } from '../../data/Assets';

interface ICheckBoxProps {
    checked: boolean;
    disabled?: boolean;
    onClick: (event: React.MouseEvent<HTMLButtonElement>, checked: boolean) => void;
}

const CheckBox = (props: ICheckBoxProps) => {
    const { checked, disabled, onClick } = props;

    return (
        <div className="immployer__checkbox">
            <button className={`immployer__checkbox__container ${disabled ? 'immployer__checkbox__container__disabled' : ''}`} onClick={(event) => onClick(event, !checked)}>
                {checked && <SVGIcon src={Icons.Checkmark} />}
            </button>
        </div>
    )
}

export default CheckBox